import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Delegate {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async count() {
        const res = await this.base.get('/api/delegates/count');
        const result = res.data;
        return result;
    }
    async getVoters(username) {
        const params = {
            username: username,
        };
        const res = await this.base.get('/api/delegates/getVoters', params);
        const result = res.data;
        return result;
    }
    async getOwnVotes(params) {
        const res = await this.base.get('/api/delegates/getOwnVotes', params);
        const result = res.data;
        return result;
    }
    async getDelegateByPubKey(publicKey) {
        const params = {
            publicKey: publicKey,
        };
        const res = await this.base.get('/api/delegates/get', params);
        const result = res.data;
        return result;
    }
    async getDelegateByUsername(username) {
        const params = {
            username: username,
        };
        const res = await this.base.get('/api/delegates/get', params);
        const result = res.data;
        return result;
    }
    async getDelegateByAddress(address) {
        const params = {
            address: address,
        };
        const res = await this.base.get('/api/delegates/get', params);
        const result = res.data;
        return result;
    }
    async ownProducedBlocks(params) {
        const res = await this.base.get('/api/delegates/ownProducedBlocks', params);
        const result = res.data;
        return result;
    }
    async getDelegates(offset, limit) {
        const params = {
            offset: offset,
            limit: limit,
        };
        const res = await this.base.get('/api/delegates', params);
        const result = res.data;
        return result;
    }
    async forgingStatus(publicKey) {
        const params = {
            publicKey: publicKey,
        };
        const res = await this.base.get('/api/delegates/forging/status', params);
        const result = res.data;
        return result;
    }
    async search(addressOrPartialUsername, offset, limit) {
        const params = {
            searchFor: addressOrPartialUsername,
            offset: offset,
            limit: limit,
        };
        const res = await this.base.get('/api/delegates/search', params);
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=delegate.js.map